import { Injectable } from '@angular/core';
import { VassNavigationItem } from '@vass/components/navigation';

import { VassMockApiService } from '@vass/lib/mock-api';
import { cloneDeep } from 'lodash-es';
import { defaultNavigation } from './data';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
  private readonly _defaultNavigation: VassNavigationItem[] = defaultNavigation;

  /**
   * Constructor
   */

  constructor(private _vassMockApiService: VassMockApiService) {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Navigation - GET
    // -----------------------------------------------------------------------------------------------------
    this._vassMockApiService.onGet('api/common/navigation').reply(() => {
      // Fill compact navigation children using the default navigation

      // Return the response
      return [
        200,
        {
          default: cloneDeep(this._defaultNavigation),
        },
      ];
    });
  }
}
